import { render, staticRenderFns } from "./GroupOpeningsAccordion.vue?vue&type=template&id=0ee10719&"
import script from "./GroupOpeningsAccordion.vue?vue&type=script&lang=js&"
export * from "./GroupOpeningsAccordion.vue?vue&type=script&lang=js&"
import style0 from "./GroupOpeningsAccordion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports